import React from 'react';
import { useTranslation } from 'react-i18next';

const HexDumpView: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('readback.hexDump')}
      </h3>
      <pre className="bg-gray-50 dark:bg-gray-900 rounded p-4 text-xs font-mono text-gray-600 dark:text-gray-400 overflow-auto max-h-96">
        {/* Hex dump output will be rendered here */}
        No readback data
      </pre>
    </div>
  );
};

export default HexDumpView;
